import { XMarkIcon } from "@heroicons/react/24/outline";

type DomainRedirectDialogProps = {
  fromHostname: string;
  onCancel: () => void;
  onConfirm: () => void;
  open: boolean;
  toHostname: string;
};

export default function DomainRedirectDialog({
  fromHostname,
  onCancel,
  onConfirm,
  open,
  toHostname,
}: DomainRedirectDialogProps) {
  if (!open) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" role="dialog" aria-modal="true">
      <button
        type="button"
        aria-label="Close redirect dialog"
        className="absolute inset-0 bg-gray-900/20 backdrop-blur-sm"
        onClick={onCancel}
      />
      <div className="relative w-full max-w-md rounded-lg bg-white p-6 shadow-lg">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h2 className="text-lg font-semibold text-gray-900">Confirm website</h2>
            <p className="mt-2 text-sm text-gray-600">
              <span className="font-medium text-gray-900">{fromHostname}</span> redirects to{" "}
              <span className="font-medium text-gray-900">{toHostname}</span>. Add the redirected website instead?
            </p>
          </div>
          <button type="button" className="text-gray-400 hover:text-gray-600" onClick={onCancel} aria-label="Close">
            <XMarkIcon className="h-5 w-5" aria-hidden="true" />
          </button>
        </div>

        <div className="mt-6 flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
          <button type="button" className="btn" onClick={onCancel}>
            Cancel
          </button>
          <button type="button" className="btn btn-primary" onClick={onConfirm}>
            Add {toHostname}
          </button>
        </div>
      </div>
    </div>
  );
}
